import React from 'react';

interface Props {
  img: string;
  name: string;
  direction?: 'row' | 'col';
}

const ItemParticipant: React.FC<Props> = ({ img, name, direction = 'col' }) => {
  const isRow = direction === 'row';

  return (
    <div
      className={[
        'flex',
        isRow ? 'flex-row items-center space-x-4' : 'flex-col items-center space-y-1',
        // quita cualquier width fijo aquí
      ].join(' ')}
    >
      {/* Ajusta el tamaño con clases válidas, por ejemplo w-10 h-10 para 2.5rem (40px) */}
      <img src={img} alt={name} className="w-14 h-14 rounded-[24px] flex-shrink-0 object-cover" />

      <span
        className={
          isRow
            ? 'tv-text-base font-bold text-white text-center'
            : 'tv-text-xs font-semibold text-white text-center'
        }
      >
        {name}
      </span>
    </div>
  );
};

export default ItemParticipant;
